"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const preProcessor_1 = require("./preProcessor");
const envParser_1 = require("./envParser");
const astUtils_1 = require("./astUtils");
const errorUtils_1 = require("./errorUtils");
function mapLoc(loc, mapper) {
    const first = preProcessor_1.getLoc(mapper, loc.first_column);
    const last = preProcessor_1.getLoc(mapper, loc.last_column);
    return {
        first_column: first.column,
        last_column: last.column,
        first_line: first.line,
        last_line: last.line,
    };
}
function parse(code) {
    const [processedCode, mapper] = preProcessor_1.preProcess(code);
    try {
        const ast = envParser_1.parse(processedCode);
        return astUtils_1.mapAst(ast, (node) => {
            if (node.loc.first_line !== 1 || node.loc.last_line != 1) {
                throw errorUtils_1.createCompilerError("Unexpected multiline", node.loc, code);
            }
            return Object.assign(Object.assign({}, node), { loc: mapLoc(node.loc, mapper) });
        });
    }
    catch (e) {
        if (e.hash == null) {
            throw e;
        }
        throw errorUtils_1.createUserError(`Parse Error: ${e.message.split("\n")[3]}`, mapLoc(e.hash.loc, mapper), code);
    }
}
exports.parse = parse;
//# sourceMappingURL=parser.js.map